import { Heading, Text } from '@apollo/orbit';
import React, { Fragment } from 'react';

import { LineChartTooltipProps } from 'src/components/charts/LineChart/LineChartTooltip';
import { LocalTimestamp } from 'src/components/timestamp/Timestamp';
import { date } from 'src/lib/date/date';
import { Resolution } from 'src/lib/graphqlTypes/types';

export const InsightsLineChartTooltip = ({
  title,
  allStacks = [],
  formatValue = (_axis, value) => String(value),
  value = {
    timestamp: new Date(),
    majorStackCounts: [],
    minorStackCounts: [],
  },
  resolution = Resolution.R1D,
}: LineChartTooltipProps) => {
  return (
    <div>
      {title ? (
        <Heading variant="title" className="text-white">
          {title}
        </Heading>
      ) : null}
      {allStacks.map((axis) => (
        <Fragment key={axis.axis}>
          {axis.activeStackCounts.map(({ stackId }) => {
            const { label, unit } = axis.stacks[stackId] ?? {};
            return (
              <div className="mt-3" key={stackId}>
                <Text as="div" variant="label" className="text-white">
                  {label || ''}
                </Text>
                <div>
                  {formatValue(
                    axis.axis,
                    value[`${axis.axis}StackCounts`][stackId]?.value ?? 0,
                    axis.maxYValue,
                  )}
                  {unit}
                </div>
              </div>
            );
          })}
        </Fragment>
      ))}
      <Text as="div" variant="label" className="mt-3 text-white">
        From
      </Text>
      <div>
        <LocalTimestamp withTooltip={false} value={value.timestamp} />
      </div>
      <Text as="div" variant="label" className="mt-3 text-white">
        To
      </Text>
      <div>
        <LocalTimestamp
          withTooltip={false}
          value={date.incrementByResolution(value.timestamp, resolution)}
        />
      </div>
    </div>
  );
};
